<template>
  <router-view name="showcaseCategory" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "ShowcaseCategory",
};
</script>
